import client from '@/api/client';

/** Which media-plan rows the briefing-rows endpoint is asked for. */
export interface BriefingRowScope {
  platform: string;
  format: string;
}

/**
 * The rows that can be briefed today. V1 is Meta Image only; the next
 * platform or format is added here, for the library's row panel, its basket
 * eligibility and My Briefs' stale-row check alike.
 */
export const BRIEFING_ROW_SCOPE: BriefingRowScope = { platform: 'Meta', format: 'Image' };

/**
 * Whether a row, as a brief line remembers it, falls inside `scope` — and so
 * whether a lookup of `scope`'s waiting rows can say anything about it. A row
 * outside it, or one saved before its format was kept, can't be judged.
 */
export function isInBriefingScope(
  row: { platform: string | null; format: string | null },
  scope: BriefingRowScope = BRIEFING_ROW_SCOPE,
): boolean {
  return (
    row.platform?.toLowerCase() === scope.platform.toLowerCase() &&
    row.format?.toLowerCase() === scope.format.toLowerCase()
  );
}

/** Slim projection of a campaign row returned by the briefing-rows endpoint. */
export interface BriefingRow {
  id: string;
  campaign_id: string;
  plan_id: string;
  nameplate: string;
  format: string;
  size: string;
  quarter: string;
  market: string;
  platform: string;
  channel: string | null;
  tier: string | null;
}

interface BriefingRowsResponse {
  rows: BriefingRow[];
}

export async function fetchBriefingRows(platform: string, format: string): Promise<BriefingRow[]> {
  const response = await client.get<BriefingRowsResponse>('/campaigns/briefing-rows', {
    params: { platform, format },
  });
  return response.data.rows;
}
